import { Injectable } from '@angular/core';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';

// Define the custom date format for 'dd.MM.yyyy'
export const CUSTOM_DATE_FORMATS: MatDateFormats = {
	parse: {
		dateInput: 'DD.MM.YYYY', // Parsing format for input
	},
	display: {
		dateInput: { day: '2-digit', month: '2-digit', year: 'numeric' }, // Display format in input (locale-aware)
		monthYearLabel: { month: 'short', year: 'numeric' }, // Month and year label in picker
		dateA11yLabel: { day: 'numeric', month: 'long', year: 'numeric' }, // Accessible date format
		monthYearA11yLabel: { month: 'long', year: 'numeric' }, // Accessible month/year format
	},
};

@Injectable({ providedIn: 'root' })
export class CustomDateAdapter extends NativeDateAdapter {
	override parse(value: any): Date | null {
		if (typeof value === 'string' && (value.includes('.') || value.includes('/'))) {
			const separator = value.includes('.') ? '.' : '/';
			const str = value.split(separator);

			const year = Number(str[2]);
			const month = Number(str[1]) - 1;
			const date = Number(str[0]);

			return new Date(year, month, date);
		}
		const timestamp = typeof value === 'number' ? value : Date.parse(value);
		return Number.isNaN(timestamp) ? null : new Date(timestamp);
	}

	override format(date: Date, displayFormat: object): string {
		date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
		displayFormat = Object.assign({}, displayFormat, { timeZone: 'utc' });

		const dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
		return dtf.format(date).replace(/[\u200E\u200F]/g, '');
	}

	override getFirstDayOfWeek(): number {
		// 0 Sunday, 1 Monday
		return 1;
	}
}
